import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  open() {
    this.element.classList.add("open");
  }

  close(_event, modal) {
    const element = modal || this.element;
    element.classList.remove("open");
    this.dispatch('closed');
  }
}
